import React from '@root/vendor/react';

const AbTestContext = React.createContext();

export default AbTestContext;
